module.exports = __webpack_public_path__ + "img/logo-eaav-h.be56c206.svg";